import { Navigate } from 'react-router-dom';
import { DEV_AUTH_ENABLED } from '@/utils/runtime';
import { getSessionInfo } from '@/utils/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  // In dev mode with auth disabled, allow access without token
  if (DEV_AUTH_ENABLED) {
    return <>{children}</>;
  }

  if (!getSessionInfo().isAuthenticated) {
    // User is not authenticated, redirect to login
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
